import React from 'react';
import type { IIconProps } from '@/types/common-types';

const HeaderIcon: React.FC<IIconProps> = (props) => {
  const { className = '', onClick } = props;
  return (
    <div className={`${className}`} onClick={onClick}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 375 122"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_2668_27815"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="375"
          height="122"
        >
          <rect
            width="375"
            height="122"
            fill="url(#paint0_linear_2668_27815)"
          />
        </mask>
        <g mask="url(#mask0_2668_27815)">
          <circle
            cx="332"
            cy="136"
            r="162"
            fill="url(#paint1_linear_2668_27815)"
            fillOpacity="0.13"
          />
          <circle
            cx="331.5"
            cy="134.5"
            r="73.5"
            fill="url(#paint2_linear_2668_27815)"
            fillOpacity="0.13"
          />
          <circle
            cx="48"
            cy="54"
            r="80"
            transform="rotate(-180 48 54)"
            fill="url(#paint3_linear_2668_27815)"
            fillOpacity="0.13"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_2668_27815"
            x1="316.5"
            y1="116.917"
            x2="250.303"
            y2="-54.5163"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#57B5EA" />
            <stop offset="1" stopColor="#2871FF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2668_27815"
            x1="194.453"
            y1="11.6981"
            x2="431.34"
            y2="193.057"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2668_27815"
            x1="269.094"
            y1="78.1038"
            x2="376.571"
            y2="160.387"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2668_27815"
            x1="-19.9245"
            y1="-7.38366"
            x2="97.0566"
            y2="82.1761"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default HeaderIcon;
